<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Equipes</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label> <span class="required">*</span> Nome: </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="entity.name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label> <span class="required">*</span> Placa: </label>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="entity.plate"
                            v-mask="plateMask"
                            :placeholder="plateModel === 1 ? 'ABC1D23' : 'ABC1234'"
                          />
                          <div class="input-group-append">
                            <button
                              type="button"
                              class="btn"
                              :class="plateModel === 1 ? 'btn-primary' : 'btn-outline-secondary'"
                              @click="togglePlateModel"
                            >
                              {{ plateModel === 1 ? 'Mercosul' : 'Padrão' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label> <span class="required">*</span> Agência: </label>
                        <v-select
                          v-model="entity.central_id"
                          class="vselect"
                          :options="centrals"
                          :reduce="(c) => c.id"
                          label="fantasy_name"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Status:</label>
                        <v-select
                          v-model="entity.status"
                          class="vselect"
                          :options="statusOptions"
                          :reduce="(s) => s.value"
                          label="label"
                          :clearable="false"
                        />
                      </div>
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                  </form>
                </div>
              </div>
              <div class="block text-right">
                <router-link to="/teams" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-add" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  computed: {
    plateMask() {
      return this.plateModel === 1 ? 'aaa-9a99' : 'aaa-9999';
    },
  },
  data() {
    return {
      centrals: [],
      plateModel: 0,
      statusOptions: [
        { label: 'Ativo', value: 1 },
        { label: 'Inativo', value: 0 },
      ],
      entity: {
        name: null,
        plate: null,
        plate_model: 0,
        central_id: null,
        status: 1,
      },
    };
  },
  methods: {
    togglePlateModel() {
      this.plateModel = this.plateModel === 1 ? 0 : 1;
      this.entity.plate_model = this.plateModel;
      this.entity.plate = null;
    },
    save() {
      const self = this;
      let api = self.$store.state.api + "teams";

      if (self.entity.id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.id;
      }

      axios
        .post(api, self.entity)
        .then(() => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push("/teams");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity(id) {
      const self = this;
      const api = self.$store.state.api + "teams/" + id;

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
          self.plateModel = self.entity.plate_model ?? 0;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCentrals() {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.fantasy_name.localeCompare(b.fantasy_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    const id = self.$route.params.id;
    if (id) {
      self.getEntity(id);
    }
    self.getCentrals();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
